import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { buildProviders, KalDate } from '@kalidea/kaligraphi';
import { tap } from 'rxjs/operators';
import { CustomFormControlAccess } from 'src/app/_core/tools/custom-form-control-access';
import {
    AdvancedRuleService,
    DataTypes
} from 'src/app/_shared/services/advanced-rule/advanced-rule.service';
import { getISODate } from 'src/app/utils/date.utils';
import { environment } from 'src/environments/environment';
import { ChampListeValeurDto, MoteurCritereDto } from 'src/graphql/generated-types';
import { toNumber } from 'src/app/utils/number.utils';

export function getDataTypeFromString(code: string): DataTypes {
    switch (code) {
        case DataTypes.List:
            return DataTypes.List;
        case DataTypes.Text:
            return DataTypes.Text;
        case DataTypes.Boolean:
            return DataTypes.Boolean;
        case DataTypes.Date:
            return DataTypes.Date;
        case DataTypes.Integer:
            return DataTypes.Integer;
        default:
            return DataTypes.Number;
    }
}

@Component({
    selector: 'app-shared-advanced-rule-criterion-value-control',
    templateUrl: './shared-advanced-rule-criterion-value-control.component.html',
    styleUrls: ['./shared-advanced-rule-criterion-value-control.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: buildProviders(SharedAdvancedRuleCriterionValueControlComponent),
    standalone: false
})
export class SharedAdvancedRuleCriterionValueControlComponent extends CustomFormControlAccess implements OnInit {

    control = new FormControl();

    criterion: MoteurCritereDto;

    DataTypes = DataTypes;

    dataType = DataTypes.Number;

    availableValues: ChampListeValeurDto[] = [];

    constructor(private advancedRuleService: AdvancedRuleService) {
        super();
    }

    @Input()
    set criterionId(id: number) {
        this.criterion = this.advancedRuleService.criteriaList.find(({Id}) => Id === id);

        if (!this.criterion) {
            this.dataType = DataTypes.Number;
            this.availableValues = [];
            return;
        }

        this.dataType = getDataTypeFromString(this.criterion.TypeDonnee?.Code);
        this.availableValues = this.criterion?.Champ?.ListChampListeValeur?.ChampListeValeurDTO || [];
    }

    writeValue(value: string | boolean | number | KalDate): void {
        switch (this.dataType) {
            case DataTypes.Date:
                value = new KalDate(value as string, environment.date.format.isoQuery);
                break;
            case DataTypes.Text:
                value = value as string || null;
                break;
            default:
                const parsedNumberValue = toNumber(value as string);
                value = parsedNumberValue === 0 ? parsedNumberValue : (parsedNumberValue || null);
        }

        this.control.patchValue(value, {emitEvent: false});

        super.writeValue(value);
    }

    setDisabledState(isDisabled: boolean): void {
        if (isDisabled) {
            this.control.disable({emitEvent: false});
        } else {
            this.control.enable({emitEvent: false});
        }
    }

    ngOnInit(): void {
        this.watch$ = this.control.valueChanges.pipe(tap(value => {
            switch (this.dataType) {
                case DataTypes.Boolean:
                    this.notifyUpdate(!value ? '0' : '1');
                    break;
                case DataTypes.Date:
                    this.notifyUpdate(getISODate(value));
                    break;
                default:
                    this.notifyUpdate('' + value);
            }
        }));
    }

}
